import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Link } from "react-router-dom";

import Localization from "../../localization";
import Button from "../../components/button";
import Filter from "./filter";
import Marquee from "../../components/marquee";
import { getUrl } from "../../utils/helper";
import { loadArtists } from "../../redux/actions/artists";
import { getArtistsList } from "../../redux/selectors/artist";
import AnimateHeight from "react-animate-height";
import IconArrow from "../../components/icons/arrow";

class Artists extends Component {
    constructor(props) {
        super(props);

        this.state = {
            char: null,
            selectedSeason: [],
            selectedProject: [],
            selectedType: [],
            seasonOpened: false,
            projectOpened: false,
            typeOpened: false,
        };
    }

    componentDidMount() {
        this.props.loadArtists();
    }

    _renderArtist(item) {
        const { locale } = this.props;

        return (
            <div key={item.slug} className="mb-20 xl:mb-0">
                <Link
                    to={getUrl("artists/" + item.slug)}
                    className="text-pink text-20 xl:text-26 font-bold"
                    title={item.name}
                >
                    {item.name}
                </Link>
                <p className="text-pink text-20 xl:text-23 mt-4 ml-30">
                    {Localization[locale].calendar[item.project]}
                </p>
            </div>
        );
    }

    componentDidUpdate(prevProps) {
        if (prevProps.data.length === 0 && this.props.data.length > 0) {
            const seasons = this.props.data
                .map((a) => a.season)
                .filter((item, index, arr) => {
                    return item && arr.indexOf(item) === index;
                })
                .sort((a, b) => b.localeCompare(a));

            if (seasons.length > 0) {
                this.setState({
                    selectedSeason: seasons[0],
                });
            }
        }
    }

    _renderArtists() {
        const { data } = this.props;
        const { selectedSeason, selectedProject, selectedType } = this.state;

        let values = data.slice();

        if (selectedSeason.length > 0) {
            values = values.filter((value) => {
                return selectedSeason.includes(value.season);
            });
        }

        if (selectedProject.length > 0) {
            values = values.filter((value) => {
                return selectedProject.includes(value.project);
            });
        }

        if (selectedType.length > 0) {
            values = values.filter((value) => {
                return selectedType.includes(value.type);
            });
        }

        return (
            <div className="xl:grid grid-cols-2 gap-32">
                {values.map((item) => this._renderArtist(item))}
            </div>
        );
    }

    _renderSeasons = () => {
        const { data, locale } = this.props;
        const { seasonOpened } = this.state;

        if (!data) return null;

        const seasons = data
            .map((a) => a.season)
            .filter((item, index, arr) => {
                return item && arr.indexOf(item) === index;
            })
            .sort((a, b) => a.localeCompare(b));

        if (seasons.length < 2) return null;

        return (
            <div className="border border-pink px-12 rounded-2xl text-23 font-bold text-pink">
                <button
                    className="w-full flex flex-row justify-between items-center py-6"
                    type="button"
                    onClick={() => {
                        this.setState({
                            seasonOpened: !this.state.seasonOpened,
                        });
                    }}
                >
                    <p>{Localization[locale].artist.season}</p>
                    <IconArrow
                        className={`w-15 h-15 transform transition-transform ${
                            seasonOpened ? "rotate-0" : "rotate-180"
                        }`}
                    />
                </button>
                <AnimateHeight
                    id="season"
                    duration={300}
                    height={seasonOpened ? "auto" : 0}
                >
                    <div className="py-6">
                        {seasons.map((season) => (
                            <button
                                onClick={() => {
                                    const index =
                                        this.state.selectedSeason.indexOf(
                                            season
                                        );
                                    if (index > -1) {
                                        const newArray =
                                            this.state.selectedSeason.slice();
                                        newArray.splice(index, 1);
                                        this.setState({
                                            selectedSeason: newArray,
                                        });
                                    } else {
                                        this.setState({
                                            selectedSeason: [
                                                ...this.state.selectedSeason,
                                                season,
                                            ],
                                        });
                                    }
                                }}
                                className={`block transition-opacity ${
                                    this.state.selectedSeason.includes(season)
                                        ? "opacity-100"
                                        : "opacity-50 hover:opacity-75"
                                }`}
                                type="button"
                            >
                                {season + "/" + (parseInt(season) + 1)}
                            </button>
                        ))}
                    </div>
                </AnimateHeight>
            </div>
        );
    };

    _renderProjects = () => {
        const { data, locale } = this.props;
        const { projectOpened } = this.state;

        if (!data) return null;

        const projects = data
            .map((a) => a.project)
            .filter((item, index, arr) => {
                return item && arr.indexOf(item) === index;
            })
            .sort((a, b) => a.localeCompare(b));

        if (projects.length < 2) return null;

        return (
            <div className="border border-pink px-12 rounded-2xl text-23 font-bold text-pink mt-12">
                <button
                    className="w-full flex flex-row justify-between items-center py-6"
                    type="button"
                    onClick={() => {
                        this.setState({
                            projectOpened: !this.state.projectOpened,
                        });
                    }}
                >
                    <p>{Localization[locale].artist.project}</p>
                    <IconArrow
                        className={`w-15 h-15 transform transition-transform ${
                            projectOpened ? "rotate-0" : "rotate-180"
                        }`}
                    />
                </button>
                <AnimateHeight
                    id="project"
                    duration={300}
                    height={projectOpened ? "auto" : 0}
                >
                    <div className="py-6">
                        {projects.map((project) => (
                            <button
                                onClick={() => {
                                    const index =
                                        this.state.selectedProject.indexOf(
                                            project
                                        );
                                    if (index > -1) {
                                        const newArray =
                                            this.state.selectedProject.slice();
                                        newArray.splice(index, 1);
                                        this.setState({
                                            selectedProject: newArray,
                                        });
                                    } else {
                                        this.setState({
                                            selectedProject: [
                                                ...this.state.selectedProject,
                                                project,
                                            ],
                                        });
                                    }
                                }}
                                className={`block transition-opacity ${
                                    this.state.selectedProject.includes(project)
                                        ? "opacity-100"
                                        : "opacity-50 hover:opacity-75"
                                }`}
                                type="button"
                            >
                                {Localization[locale].calendar[project]}
                            </button>
                        ))}
                    </div>
                </AnimateHeight>
            </div>
        );
    };

    _renderTypes = () => {
        const { data, locale } = this.props;
        const { typeOpened } = this.state;

        if (!data) return null;

        const types = data
            .map((a) => a.type)
            .filter((item, index, arr) => {
                return item && arr.indexOf(item) === index;
            })
            .sort((a, b) => a.localeCompare(b));

        if (types.length < 2) return null;

        return (
            <div className="border border-pink px-12 rounded-2xl text-23 font-bold text-pink mt-12">
                <button
                    className="w-full flex flex-row justify-between items-center py-6"
                    type="button"
                    onClick={() => {
                        this.setState({
                            typeOpened: !this.state.typeOpened,
                        });
                    }}
                >
                    <p>{Localization[locale].artist.type}</p>
                    <IconArrow
                        className={`w-15 h-15 transform transition-transform ${
                            typeOpened ? "rotate-0" : "rotate-180"
                        }`}
                    />
                </button>
                <AnimateHeight
                    id="type"
                    duration={300}
                    height={typeOpened ? "auto" : 0}
                >
                    <div className="py-6">
                        {types.map((type) => (
                            <button
                                onClick={() => {
                                    const index =
                                        this.state.selectedType.indexOf(type);
                                    if (index > -1) {
                                        const newArray =
                                            this.state.selectedType.slice();
                                        newArray.splice(index, 1);
                                        this.setState({
                                            selectedType: newArray,
                                        });
                                    } else {
                                        this.setState({
                                            selectedType: [
                                                ...this.state.selectedType,
                                                type,
                                            ],
                                        });
                                    }
                                }}
                                className={`block transition-opacity ${
                                    this.state.selectedType.includes(type)
                                        ? "opacity-100"
                                        : "opacity-50 hover:opacity-75"
                                }`}
                                type="button"
                            >
                                {Localization[locale].artist.types[type]}
                            </button>
                        ))}
                    </div>
                </AnimateHeight>
            </div>
        );
    };

    _renderMobile() {
        const { locale, data } = this.props;

        if (!data) return null;

        const seasons = data
            .map((a) => a.season)
            .filter((item, index, arr) => {
                return item && arr.indexOf(item) === index;
            })
            .sort((a, b) => a.localeCompare(b));

        const projects = data
            .map((a) => a.project)
            .filter((item, index, arr) => {
                return item && arr.indexOf(item) === index;
            })
            .sort((a, b) => a.localeCompare(b));

        const types = data
            .map((a) => a.type)
            .filter((item, index, arr) => {
                return item && arr.indexOf(item) === index;
            })
            .sort((a, b) => a.localeCompare(b));

        return (
            <div className="sticky bottom-0 pb-30 bg-blue left-0 right-0 xl:hidden border-t border-pink pt-8 mt-40 px-16">
                <div className="flex mt-12">
                    <div className="relative flex-1 mr-16">
                        <select
                            className="absolute w-full opacity-0"
                            id="season-select"
                            onChange={({ target: { value } }) => {
                                if (value === "all") {
                                    this.setState({
                                        selectedSeason: [],
                                    });
                                    return;
                                }
                                this.setState({
                                    selectedSeason: [value],
                                });
                            }}
                        >
                            <option value={"all"}>
                                {Localization[locale].home.blog_filter_all}
                            </option>
                            {seasons.map((season) => (
                                <option key={season} value={season}>
                                    {season + "/" + (parseInt(season) + 1)}
                                </option>
                            ))}
                        </select>
                        <Button
                            text={Localization[locale].artist.season}
                            backgroundColorOver={"bg-pink"}
                            borderColor={"border-pink"}
                            textStyle={
                                "font-bold text-20 xl:text-23 z-10 transition hover-hover:group-hover:text-blue text-pink"
                            }
                            style={"pointer-events-none w-full"}
                        />
                    </div>
                    <div className="relative flex-1">
                        <select
                            className="absolute w-full opacity-0"
                            id="project-select"
                            onChange={({ target: { value } }) => {
                                if (value === "all") {
                                    this.setState({
                                        selectedProject: [],
                                    });
                                    return;
                                }
                                this.setState({
                                    selectedProject: [value],
                                });
                            }}
                        >
                            <option value={"all"}>
                                {Localization[locale].home.blog_filter_all}
                            </option>
                            {projects.map((project) => (
                                <option key={project} value={project}>
                                    {Localization[locale].calendar[project]}
                                </option>
                            ))}
                        </select>
                        <Button
                            text={Localization[locale].artist.project}
                            backgroundColorOver={"bg-pink"}
                            borderColor={"border-pink"}
                            textStyle={
                                "font-bold text-20 xl:text-23 z-10 transition hover-hover:group-hover:text-blue text-pink"
                            }
                            style={"pointer-events-none w-full"}
                        />
                    </div>
                    {types.length > 2 && (
                        <div className="relative flex-1 ml-16">
                            <select
                                className="absolute w-full opacity-0"
                                id="char-select"
                                onChange={({ target: { value } }) => {
                                    if (value === "all") {
                                        this.setState({
                                            selectedType: [],
                                        });
                                        return;
                                    }
                                    this.setState({
                                        selectedType: [value],
                                    });
                                }}
                            >
                                <option value={"all"}>
                                    {Localization[locale].home.blog_filter_all}
                                </option>
                                {types.map((type) => (
                                    <option key={type} value={type}>
                                        {
                                            Localization[locale].artist.types[
                                                type
                                            ]
                                        }
                                    </option>
                                ))}
                            </select>
                            <Button
                                text={Localization[locale].artist.type}
                                backgroundColorOver={"bg-pink"}
                                borderColor={"border-pink"}
                                textStyle={
                                    "font-bold text-20 xl:text-23 z-10 transition hover-hover:group-hover:text-blue text-pink"
                                }
                                style={"pointer-events-none  w-full"}
                            />
                        </div>
                    )}
                </div>
            </div>
        );
    }

    _renderMain() {
        return (
            <div className="bg-blue pt-40 xl:pt-100 pb-0 xl:pb-100 xl:px-50">
                <div className="flex flex-col xl:flex-row">
                    <div className="hidden xl:flex flex-col px-16 xl:w-3/12">
                        {this._renderSeasons()}
                        {this._renderProjects()}
                        {this._renderTypes()}
                    </div>
                    <div className="flex-1 hidden xl:flex" />
                    <div className="xl:w-8/12 px-16">
                        {this._renderArtists()}
                    </div>
                    {this._renderMobile()}
                </div>
            </div>
        );
    }

    render() {
        const { artistsData } = this.props;

        if (!artistsData) return <div className="h-screen" />;

        return (
            <div>
                <Marquee backgroundColor={"bg-blue"} color={"pink"} />
                {this._renderMain()}
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    locale: state.app.locale,
    artistsData: state.pages.artists,
    data: getArtistsList(state),
});

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(
        {
            loadArtists,
        },
        dispatch
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(Artists);
